module.exports = __webpack_public_path__ + "static/img/6767_phase_function_Paper_Points.f06ae43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6767_phase_function_Paper_Points.png
// module id = 8/5a
// module chunks = 0